import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PublishingStore, for use in the registry */ export const PublishingStoreActionTypes = [
    ActionType.FetchPublications,
    ActionType.FetchPublicationsSucceeded,
    ActionType.FetchPublicationsFailed
];
